export default [
  {
    path: '/AttendanceManagement',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/AttendanceManagement/',
        name: 'AttendanceManagement',
        component: () => import('@/views/AttendanceManagement/AttendanceManagement.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: '/AttendanceManagement_Clock',
        name: 'AttendanceManagement_Clock',
        component: () => import('@/views/AttendanceManagement/AttendanceManagement_Clock.vue'),
        meta: {
          prev: 'AttendanceManagement'
        }
      },
      {
        path: '/AttendanceRecord',
        name: 'AttendanceRecord',
        component: () => import('@/views/AttendanceManagement/AttendanceRecord.vue'),
        meta: {
          prev: 'AttendanceManagement'
        }
      }
    ]
  }
]
